import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { globalStore } from '../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectFolderId } from '../../../store/person/person.selectors';
import { FolderDataShareObject } from '@libs/types/src/services/object-type/folder/folder-data-share.object';

@Injectable()
export class PersonShareDataWithServiceStore extends ComponentStoreV2Factory {
    folderId = toSignal(globalStore!.select(selectFolderId));
    items = computed<FolderDataShareObject[]>(() => this.data.getFolderDataShares()?.items || []);
}

